import { fetchAuthenticatedJson } from './authenticatedFetch';

function buildQuery(params = {}) {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') {
      return;
    }
    query.set(key, value);
  });
  const queryString = query.toString();
  return queryString ? `?${queryString}` : '';
}

async function fetchJson(url, options = {}) {
  const payload = await fetchAuthenticatedJson(url, {
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
    ...options,
  });
  return payload;
}

export function fetchMailCenterOverview() {
  return fetchJson('/api/admin/mail-center/overview');
}

export function fetchContactMessages(filters = {}) {
  return fetchJson(`/api/admin/contact-messages${buildQuery(filters)}`);
}

export function updateContactMessage(id, payload) {
  return fetchJson(`/api/admin/contact-messages/${id}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
}

export function replyToContactMessage(id, payload) {
  return fetchJson(`/api/admin/contact-messages/${id}/reply`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function fetchEmailLogs(filters = {}) {
  return fetchJson(`/api/admin/email-logs${buildQuery(filters)}`);
}

export function fetchNotifications(filters = {}) {
  return fetchJson(`/api/admin/notifications${buildQuery(filters)}`);
}

export function markNotificationRead(id) {
  return fetchJson(`/api/admin/notifications/${id}/read`, {
    method: 'PUT',
  });
}

export function fetchSystemSettings() {
  return fetchJson('/api/admin/settings');
}

export function updateSystemSettings(settings) {
  return fetchJson('/api/admin/settings', {
    method: 'PUT',
    body: JSON.stringify(settings),
  });
}

export function fetchAdminUsers() {
  return fetchJson('/api/users');
}